import { render, staticRenderFns } from "./PurchaseApprovalForm.vue?vue&type=template&id=8b9730b4&scoped=true"
import script from "./PurchaseApprovalForm.vue?vue&type=script&lang=js"
export * from "./PurchaseApprovalForm.vue?vue&type=script&lang=js"
import style0 from "./PurchaseApprovalForm.vue?vue&type=style&index=0&id=8b9730b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b9730b4",
  null
  
)

export default component.exports